import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { API_BASE_URL, fetchSports } from "../../api/endpoint";
import { FaRegEdit } from "react-icons/fa";
import toast from "react-hot-toast";
import axios from "axios";
import Table from "../../components/table";
import AddSportModal from "./addSportModal";
import EditSportModal from "./editSportModal";
import RemoveSportModal from "./removeSportModal";
import { saveSportsData } from "../../store/slice/sportsSlice";
import Loader from "../../components/loader";

const Sports = () => {
  const dispatch = useDispatch();
  const [sportsList, setSportsList] = useState([]);
  const [sportsPerPage] = useState(8);
  const [isAddSportOpen, setIsAddSportOpen] = useState(false);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [isRemoveOpen, setIsRemoveOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedSportId, setSelectedSportId] = useState("");
  const { auth } = useSelector((state) => state.login);
  const { sports } = useSelector((state) => state.sports);

  useEffect(() => {
    fetchSportsList();
  }, [auth]);

  const fetchSportsList = async () => {
    try {
      setLoading(true);
      const response = await axios.get(fetchSports, {
        headers: {
          Authorization: `Bearer ${auth}`,
        },
      });
      const sportsData = response?.data?.sports?.map((sport) => ({
        id: sport?.id,
        icon: () => getIcon(sport?.icon),
        name: sport?.sportName,
        actions: () => getActionButtons(sport?.id),
      }));
      setSportsList(sportsData);
      dispatch(saveSportsData(response?.data?.sports));
    } catch (error) {
      console.error("Error fetching sports:", error);
      toast.error("Failed to load sports.");
    } finally {
      setLoading(false);
    }
  };

  const getIcon = (filename) => {
    const imgUrl = `${API_BASE_URL}public/images/${filename}`;
    if (filename) {
      return <img src={imgUrl} style={{ height: "1.5rem" }} />;
    } else {
      return "No icon available";
    }
  };

  const getActionButtons = (id) => {
    return (
      <div className="">
        <button
          className="btn p-0 me-2"
          onClick={() => {
            setSelectedSportId(id);
            setIsEditOpen(true);
          }}
        >
          <FaRegEdit size={20} />
        </button>
        {/* <button
          className="btn p-0"
          onClick={() => {
            setSelectedSportId(id);
            setIsRemoveOpen(true);
          }}
        >
          <FaTrash size={20} />
        </button> */}
      </div>
    );
  };

  const headings = [
    // { name: "ID", fieldName: "id", isSortable: true, sortKey: "none" },
    { name: "Icon", fieldName: "icon", isSortable: false, sortKey: "none" },
    { name: "Name", fieldName: "name", isSortable: true, sortKey: "none" },
    {
      name: "Actions",
      fieldName: "actions",
      isSortable: false,
      sortKey: "none",
    },
  ];

  return (
    <div className="px-md-2 px-1 py-md-2 py-1">
      {sports && (
        <Table
          headings={headings}
          data={sportsList}
          enablePagination={false}
          addBtnText="+ Add Sport"
          addCallback={() => setIsAddSportOpen(true)}
          card={true}
          pageTitle="Sports"
        />
      )}
      <AddSportModal
        isAddSportOpen={isAddSportOpen}
        closeAddSportModal={() => setIsAddSportOpen(false)}
        fetchSportsList={fetchSportsList}
      />
      <EditSportModal
        isEditOpen={isEditOpen}
        closeEditModal={() => setIsEditOpen(false)}
        fetchSportsList={fetchSportsList}
        selectedSportId={selectedSportId}
      />
      <RemoveSportModal
        isRemoveOpen={isRemoveOpen}
        closeRemoveModal={() => setIsRemoveOpen(false)}
        selectedSportId={selectedSportId}
      />
      {loading && <Loader />}
    </div>
  );
};

export default Sports;
